import { Box } from "@mui/material";
import { styled } from "@mui/system";

// Enhanced editing toolbar styles
export const EditingToolbar = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1, 2),
    backgroundColor: '#f8f9fa',
    borderBottom: '1px solid #e0e0e0',
    flexWrap: 'wrap',
    minHeight: '56px',
    position: 'sticky',
    top: 0,
    zIndex: 10,
    width: '100%',
  }));
  
export const ToolbarGroup = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    padding: theme.spacing(0, 1),
    borderRight: '1px solid #e0e0e0',
    '&:last-child': {
      borderRight: 'none',
    },
}));